<div class="row">
  <div *ngFor="let product of data" class="col-6 col-md-4 col-lg-3 mb-3">
    <div class="card product-card">
      <div class="card-body">
        <div class="image-wrapper" [routerLink]="['/product/', product.id]">
          <img
            *ngIf="product.extra.images && product.extra.images[0] as image; else noimage"
            class="img-fluid"
            src="https://cdn3.gung.io/fit-in/250x250/filters:etag({{
              product.extra.images[0].s3ETag
            }}):background_color(white):format(jpeg):fill(fff)/{{ product.extra.images[0].s3Uri }}"
            alt=""
          />
          <ng-template #noimage>
            <img
              class="card-img-top img-fluid w-100"
              src="https://cdn3.gung.io/fit-in/300x300/images/no-image.jpg"
              alt="NO IMAGE"
              class="img-fluid mx-auto d-block"
            />
          </ng-template>
        </div>
        <div class="product-text pb-1">
          <div>{{ product.id }}</div>
          <div class="text-truncate" translate>{{ product.name }}</div>
          <div *ngIf="productPriceMap[product.id] && !isReturnFlow" [ngClass]="{ 'is-clearance': !isReturnFlow && product.extra?.ar?.q_eliasson_artnr === '50' }">
            <lib-price [price]="productPriceMap[product.id]" type="NET" [currency]="productPriceMap[product.id].customerNetPrice.currencyCode"
              class="font-weight-bold"></lib-price>&nbsp;
            <span *ngIf="productPriceMap[product.id].customerDiscountPercent !== 0">(-{{ productPriceMap[product.id].customerDiscountPercent }}%)</span>
          </div>
          <div class="product-card-button">
            <lib-item-selection-button [item]="product"></lib-item-selection-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
